export default "__VITE_PUBLIC_ASSET__a5ca86a0__"